import React, { useContext } from "react";
import { RegistrationFormContext } from "./types";
import { InputRadio } from "../../../../HtmlComponents/InputRadio";
import { InputElement } from "../../../../HtmlComponents/InputElement";
import { InputCheckbox } from "../../../../HtmlComponents/InputCheckbox";

const Section11 = () => {
  const {
    contractCommunicationCompliance, setContractCommunicationCompliance,
    organizationsSeekingCollaboration, setOrganizationsSeekingCollaboration,
    languages, setLanguages,
    refusedRegistration, setRefusedRegistration,
  } = useContext(RegistrationFormContext);

  return (<>
    <div>
      <p className='font-bold text-main'>{"40) "}Avez-vous conformement aux dispositions reglementaires, communiqué votre{" (vos)"} contract{"(s)"} a l'ordre: </p>
      <InputRadio 
        checked={contractCommunicationCompliance === "Oui" && true} 
        labelName="Oui"
        id="contractCommunicationComplianceOui" 
        value={"Oui"} 
        setValue={setContractCommunicationCompliance}
      />
      <InputRadio 
        checked={(contractCommunicationCompliance && contractCommunicationCompliance !== "Oui") ? true : false} 
        labelName="Non"
        id="contractCommunicationComplianceNon" 
        value={"Non"} 
        setValue={setContractCommunicationCompliance}
      />
      {contractCommunicationCompliance && contractCommunicationCompliance !== "Oui" && <InputElement inputClass='md:w-1/2' name='Pourquoi?' value={contractCommunicationCompliance} setValue={setContractCommunicationCompliance}/>}
    </div>
    <div>
      <p className='font-bold text-main'>{"41) "}Existent-ils des organismes qui font appel à votre concours (Tribunaux, Assurance, Société, Établissement public ou privé): </p>
      <InputCheckbox
        name="Oui"
        id="organizationsSeekingCollaboration" 
        value={organizationsSeekingCollaboration} 
        setValue={setOrganizationsSeekingCollaboration}
      />
      {(organizationsSeekingCollaboration && (organizationsSeekingCollaboration !== "false" && typeof organizationsSeekingCollaboration === "string")) && <InputElement inputClass='md:w-1/2' name='Laquelle?' value={organizationsSeekingCollaboration} setValue={setOrganizationsSeekingCollaboration}/>}
    </div>
    <div>
      <p className='font-bold text-main'>{"42) "}parlez-vous une ou deux languages etrangeres: </p>
      <InputCheckbox 
        name="Oui"
        id="languages" 
        value={languages} 
        setValue={setLanguages}
      />
      {(languages || typeof languages === "string") && <InputElement inputClass='md:w-1/2' name='Laquelle?' value={languages} setValue={setLanguages}/>}
    </div>
    <div>
      <p className='font-bold text-main'>{"43) "}Avez-vous subi un refus d'inscription: </p>
      <InputCheckbox 
        name="Oui"
        id="refusedRegistration" 
        checked={refusedRegistration === "Oui"} 
        value={refusedRegistration} 
        setValue={setRefusedRegistration}
      />
      {(refusedRegistration || typeof refusedRegistration === "string") && <InputElement inputClass='md:w-1/2' name='Laquelle?' value={refusedRegistration} setValue={setRefusedRegistration}/>}
    </div> 
  </>);
};

export default Section11;
